import React from 'react';
import { experience } from '../data';

const Experience = () => {
  return (
    <section id="experience" className="container">
      <h2>Where I've Worked</h2>
      <div className="experience-list">
        {experience.map((exp, i) => (
          <div key={i} className="experience-item">
            <h3 className="role">
              {exp.role} <span>@ {exp.company}</span>
            </h3>
            <p className="date">{exp.date}</p>
            <p className="desc">{exp.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
export default Experience;